<script>
  import { format } from 'svelte-i18n';
  import { Button, ButtonGroup, Input, InputGroup, Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  // TODO use app icons, not Bootstrap
  import { generateUUID } from '@common/utils/strings';

  export let edit = false;
  export let editable = false;
  export let options = [];
  export let name;
  export let value;
  export let onChange = () => {};

  $: id = `${name}-${generateUUID()}`;
</script>

<div class="d-flex">
  {#if edit}
    <InputGroup>
      <Button id="{id}-edit" size="sm" class="px-2" on:click={() => (edit = false)}>
        <Icon name="more-horizontal" class="editor-icon" />
      </Button>
      <Tooltip target="{id}-edit">{$format('label.CHOOSE_VALUE')}</Tooltip>
      <Input {...$$restProps} {value} bsSize="sm" on:input={(e) => onChange(e.target.value)} />
    </InputGroup>
  {:else}
    <ButtonGroup size="sm" class="w-100 h-32">
      {#each options as option}
        <Button
          id="{id}-{option.label || option.value}"
          active={value === option.value}
          on:click={() => onChange(option.value)}
        >
          {#if option.html}
            {@html option.html}
          {:else if option.icon}
            <Icon name={option.icon} class="editor-icon" />
          {:else}
            {option.label}
          {/if}
        </Button>
        <Tooltip target="{id}-{option.label || option.value}" class="text-capitalize">
          {option.label || option.value}
        </Tooltip>
      {/each}

      {#if editable}
        <Button id="{id}-edit" on:click={() => (edit = true)} class="px-0">
          <Icon name="edit-2" class="editor-icon" />
        </Button>
        <Tooltip target="{id}-edit">{$format('label.EDIT_VALUE')}</Tooltip>
      {/if}
    </ButtonGroup>
  {/if}
</div>

<style lang="scss">
  :global {
    .editor-icon {
      display: block;
      font-size: var(--font-size-base);
    }

    .h-32 {
      height: 32px;
    }
  }
</style>
